import React from 'react';

const OtherfileLookUp = (mimeType) => {
    let name = '';
    let color = '';
    if (
        mimeType === 'application/vnd.ms-excel' ||
        mimeType === 'application/msexcel' ||
        mimeType === 'application/x-msexcel' ||
        mimeType === 'application/x-ms-excel' ||
        mimeType === 'application/x-excel' ||
        mimeType === 'application/x-dos_ms_excel' ||
        mimeType === 'application/xls' ||
        mimeType === 'application/x-xls' ||
        mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ) {
        name = 'table_view';
        color = 'text-excelFile';
    } else {
        name = 'description';
        color = 'text-scogodarkgray';
    }
    return { name, color };
};

const getFileIcon = (type, mimeType) => {
    const lookup = {
        image: {
            name: 'image',
            color: 'text-scogobgsky',
        },
        audio: {
            name: 'volume_up',
            color: 'text-gray-900',
        },
        video: { name: 'videocam', color: 'text-gray-900' },
        pdf: { name: 'picture_as_pdf', color: 'text-scogoclosed' },
        others: OtherfileLookUp(mimeType),
        text: { name: 'text_snippet', color: 'text-noteFile' },
    };
    return <span className={`material-icons ${lookup[type]?.color}`}>{lookup[type]?.name}</span>;
};

const getComponentByType = ({ type, url }) => {
    const lookup = {
        image: <img src={url} className='h-20 w-20 object-cover rounded-md shadow-sm' alt='' />,
        audio: <img src={process.env.PUBLIC_URL + '/img/audio.png'} className='h-16 w-16 object-contain' alt='' />,
        video: <video className='h-20 w-20 object-cover rounded-md shadow-sm' src={url} />,
        pdf: <img src={process.env.PUBLIC_URL + '/img/pdf.png'} className='h-16 w-16 object-contain' alt='' />,
        others: <img src={process.env.PUBLIC_URL + '/img/unknownFileType.png'} className='h-16 w-16 object-contain' alt='' />,
        text: <img src={process.env.PUBLIC_URL + '/img/unknownFileType.png'} className='h-16 w-16 object-contain' alt='' />,
    };
    return lookup[type];
};

function ReplyBox({ message, closeReply, isChatPopup }) {
    const renderReplyMessage = () => {
        if (message.type === 'DEFAULT' || message.type === 'reply') {
            // Process content to handle @mentions
            const processContent = (content) => {
                if (!content) return '';

                // Regex to match @[Username](userId) pattern
                const regex = /@\[(.*?)\]\((.*?)\)/g;
                return content.replace(regex, (match, username) => {
                    return `@${username}`;
                });
            };

            return (
                <p className='font-medium text-gray-600 text-font14 w-11/12 line-clamp-2 break-all'>
                    {processContent(message?.content)}
                </p>
            );
        } else if (message.type === 'attachments') {
            const attachments = message.attachments;
            let { type, mimeType, fileUrl } = attachments[0];
            const isSingle = attachments.length === 1;
            return (
                <div className="flex items-center justify-between w-full">
                    <div className="flex items-center gap-2 max-w-[70%]">
                        {getFileIcon(type, mimeType)}
                        <span className="font-medium text-gray-600 truncate">
                            {type?.charAt(0).toUpperCase() + type?.slice(1)}
                            {!isSingle && (
                                <span className='text-scogoorange text-font12 font-bold ml-1'>
                                    +{attachments.length - 1}
                                </span>
                            )}
                        </span>
                    </div>
                    <div className='flex justify-center items-center h-20 w-20'>
                        {getComponentByType({ type, url: fileUrl })}
                    </div>
                </div>
            );
        } else if (message.type === 'card') {
            return <p className='text-gray-700 font-medium text-font14 line-clamp-2'>{message.payload.title}</p>;
        }
    };

    return (
        <div className={`relative w-full ${isChatPopup ? 'h-32' : 'h-36'} bg-gradient-to-r from-blue-50 to-blue-100 rounded-lg shadow-sm ${isChatPopup ? 'p-1.5' : 'p-2.5'}`}>
            <div className='w-full relative border border-blue-200 m-auto bg-white h-full p-3 rounded-md shadow-inner flex flex-col'>
                <div className="flex items-center justify-between mb-2">
                    <span className='font-semibold text-font13 text-scogoorange flex items-center'>
                        <span className="material-icons text-font16 mr-1">reply</span>
                        {message?.author?.display_name}
                    </span>
                    <button
                        className='text-gray-400 hover:text-gray-600 transition-colors p-1 rounded-full hover:bg-gray-100'
                        onClick={closeReply}
                        aria-label="Close reply"
                    >
                        <span className="material-icons text-font18">close</span>
                    </button>
                </div>
                <div className='pl-2 flex-1 flex items-center overflow-hidden'>
                    {renderReplyMessage()}
                </div>
            </div>
        </div>
    );
}

export default ReplyBox;
